import TableEmployer from "../TableEmployer";

export const TableItems = (
  filteredDataCount,
  employer,
  filteredData,
  paginatedData,
  tabKey,
  setFilteredData,
  selectedRow,
  setSelectedRow
) => {
  return [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TableEmployer
          source={employer}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    {
      label: `Active (${filteredDataCount[1]})`,
      key: 1,
      children: (
        <TableEmployer
          source={employer}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    {
      label: `Suspended (${filteredDataCount[2]})`,
      key: 2,
      children: (
        <TableEmployer
          
          source={employer}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    {
      label: `Terminated (${filteredDataCount[0]})`,
      key: 0,
      children: (
        <TableEmployer
          source={employer}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
  ];
};
